'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowLeftRight, ExternalLink } from 'lucide-react';
import { trackMarketingEvent } from '@/components/analytics/MarketingAnalytics';
import { CadrinoHrLogo } from '@/components/brand/CadrinoHrLogo';
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { useWebsitePagesCopy } from '@/lib/cadrino-landing/useWebsitePagesCopy';
import { Container, Section, SectionHeader, MotionBlock, ContentCard, CardKicker, CardTitle, CardText, PrimaryButton, SecondaryButton, SectionActions, SectionCallout, cardGridClass, sectionBandClass } from './shared';
export function IntegrationSection() {
  const $ = _c(39);
  const c = useCadrinoCopy();
  const i = c.integrationSection;
  const pages = useWebsitePagesCopy();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = sectionBandClass("muted");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== i.subtitle || $[2] !== i.title) {
    t1 = <MotionBlock><SectionHeader title={i.title} subtitle={i.subtitle} /></MotionBlock>;
    $[1] = i.subtitle;
    $[2] = i.title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== i.choices || $[5] !== i.currentBadge) {
    let t3;
    if ($[7] !== i.currentBadge) {
      t3 = (choice, idx) => {
        const isCurrent = "current" in choice && choice.current;
        return <MotionBlock key={choice.title} delay={idx * 0.05}><ContentCard highlighted={isCurrent}>{isCurrent && <CardKicker className="text-cadrino-primary">{i.currentBadge}</CardKicker>}<CardTitle className={isCurrent ? "mt-2" : undefined}>{choice.title}</CardTitle><CardText className="mt-3 flex-1">{choice.description}</CardText></ContentCard></MotionBlock>;
      };
      $[7] = i.currentBadge;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = i.choices.map(t3);
    $[4] = i.choices;
    $[5] = i.currentBadge;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <div className={cardGridClass}>{t2}</div>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-cadrino-accent/10 text-cadrino-accent ring-1 ring-cadrino-accent/15"><ArrowLeftRight className="h-5 w-5" aria-hidden={true} /></div>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== i.syncTitle) {
    t5 = <CardTitle className="text-base">{i.syncTitle}</CardTitle>;
    $[12] = i.syncTitle;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== i.syncItems) {
    t6 = i.syncItems.map(_temp);
    $[14] = i.syncItems;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = <ul className="mt-4 space-y-3">{t6}</ul>;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <MotionBlock className="mt-5"><ContentCard><div className="flex items-start gap-3">{t4}<div className="min-w-0 flex-1">{t5}{t7}</div></div></ContentCard></MotionBlock>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== i.note) {
    t9 = <SectionCallout>{i.note}</SectionCallout>;
    $[21] = i.note;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== i.ctaDemo) {
    t10 = <PrimaryButton href="#contact">{i.ctaDemo}</PrimaryButton>;
    $[23] = i.ctaDemo;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== pages.nav.integrations) {
    t11 = <SecondaryButton href="/integrations">{pages.nav.integrations}</SecondaryButton>;
    $[25] = pages.nav.integrations;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Link href="https://cadrinohr.com" target="_blank" rel="noopener noreferrer" onClick={_temp2} className="inline-flex h-11 items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50"><CadrinoHrLogo variant="forLightBg" height={20} /><ExternalLink className="h-3.5 w-3.5 text-slate-400" aria-hidden={true} /></Link>;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t11) {
    t13 = <SectionActions>{t10}{t11}{t12}</SectionActions>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13 || $[32] !== t9) {
    t14 = <MotionBlock className="mt-5 space-y-5">{t9}{t13}</MotionBlock>;
    $[31] = t13;
    $[32] = t9;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t1 || $[35] !== t14 || $[36] !== t3 || $[37] !== t8) {
    t15 = <Section id="integration" className={t0}><Container>{t1}{t3}{t8}{t14}</Container></Section>;
    $[34] = t1;
    $[35] = t14;
    $[36] = t3;
    $[37] = t8;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
}
function _temp2() {
  return trackMarketingEvent("cadrino_hr_click");
}
function _temp(item) {
  return <li key={item} className="flex gap-2.5 text-sm leading-relaxed text-cadrino-muted"><span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-cadrino-accent" aria-hidden={true} /><span>{item}</span></li>;
}